"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variant = void 0;
var Variant;
(function (Variant) {
    Variant[Variant["Experiment"] = 1] = "Experiment";
    Variant[Variant["Origin"] = 2] = "Origin";
    Variant[Variant["Culture"] = 3] = "Culture";
    Variant[Variant["DeviceType"] = 4] = "DeviceType";
    Variant[Variant["WhiteLabelId"] = 5] = "WhiteLabelId";
    Variant[Variant["WhiteLabelFeature"] = 6] = "WhiteLabelFeature";
    Variant[Variant["DomainName"] = 7] = "DomainName";
    Variant[Variant["ServerSideBehavior"] = 8] = "ServerSideBehavior";
})(Variant = exports.Variant || (exports.Variant = {}));
exports.default = Variant;
